<template>
	<div class="shop-categories">
		<div class="slider">
			<div class="item">
				<div class="container">
					<div
						class="col-12 float-left"
						style="margin-top:150px;margin-bottom:30px;"
					>
						<h1>
							فروشگاه های طرف قرارداد نیکارت در {{ provinceName }}
						</h1>
					</div>
					<div class="col-12 col-md-8 offset-md-2 float-left">
						<input
							type="text"
							@keyup="initShopCategories"
							class="form-control rounded-pill"
							placeholder="فروشگاه مورد نظر خود را جستجو کنید..."
						/>
					</div>
				</div>
			</div>
		</div>
		<div class="container p-0" :key="key">
			<div
				class="category"
				v-for="(sc, scIndex) in _shopCategories"
				:key="sc.shopCategoryId"
			>
				<div class="section-title">
					<h2>
						<router-link
							class="item d-block"
							:to="{
								name: 'shops',
								params: {
									shopCategoryId: sc.shopCategoryId,
									provinceId: provinceId,
									name: sc.shopCategoryName.replace(
										/ /gi,
										'-'
									)
								}
							}"
						>
							{{ sc.shopCategoryName }}
						</router-link>
					</h2>
					<div
						v-if="showAll[scIndex]"
						class="content"
						:options="swiperOption"
					>
						<div
							v-for="(shop, index) in sc.shops"
							class="col-6 pr-2 pl-2 mb-4 col-lg-3 float-right z-10"
						>
							<router-link
								class="item"
								:to="{
									name: 'shop',
									params: {
										id: shop.shopId,
										name: shop.name.replace(/ /gi, '-')
									}
								}"
							>
								<div class="details">
									<label>{{ shop.name }}</label>
									<small
										v-if="shop.shopWagePercent"
										title="کارمزد ماهیانه"
										class="float-left"
										>{{ shop.shopWagePercent }}%</small
									>
								</div>
								<div class="inner">
									<div
										class="img"
										v-if="shop.imagePath"
										v-bind:style="{
											'background-image':
												'url(' +
												rootImagePath +
												shop.imagePath +
												')'
										}"
									></div>
									<div
										class="img"
										v-else
										v-bind:style="{
											'background-image':
												'url(' +
												require('../../assets/image/NoImage.jpg') +
												')'
										}"
									></div>
								</div>
								<div class="score-comment">
									<div class="star-rating float-left">
										<font-awesome-icon
											:icon="
												shop.scoreAverage >= 5
													? ['fa', 'star']
													: ['far', 'star']
											"
											color="yellow"
										/>
										<font-awesome-icon
											:icon="
												shop.scoreAverage >= 4
													? ['fa', 'star']
													: ['far', 'star']
											"
											color="yellow"
										/>
										<font-awesome-icon
											:icon="
												shop.scoreAverage >= 3
													? ['fa', 'star']
													: ['far', 'star']
											"
											color="yellow"
										/>
										<font-awesome-icon
											:icon="
												shop.scoreAverage >= 2
													? ['fa', 'star']
													: ['far', 'star']
											"
											color="yellow"
										/>
										<font-awesome-icon
											:icon="
												shop.scoreAverage >= 1
													? ['fa', 'star']
													: ['far', 'star']
											"
											color="yellow"
										/>
									</div>
									<div
										class="comments float-right"
										style="color:#000;"
									>
										<font-awesome-icon
											:icon="['far', 'comment']"
											color="black"
										/>
										<b-badge class="shop-comment-badge">{{
											shop.commentsCount || 0
										}}</b-badge>
									</div>
								</div>
							</router-link>
						</div>
					</div>
					<swiper
						v-if="!showAll[scIndex]"
						class="content"
						:options="swiperOption"
					>
						<swiper-slide
							v-for="(shop, index) in sc.shops"
							:key="index"
							v-if="index < 10"
							class="col-6 pr-2 pl-2 mb-4 col-lg-3 float-right z-10"
						>
							<router-link
								class="item"
								:to="{
									name: 'shop',
									params: {
										id: shop.shopId,
										name: shop.name.replace(/ /gi, '-')
									}
								}"
							>
								<div class="details">
									<label>{{ shop.name }}</label>
									<small
										v-if="shop.shopWagePercent"
										title="کارمزد ماهیانه"
										class="float-left"
										>{{ shop.shopWagePercent }}%</small
									>
								</div>
								<div class="inner">
									<div
										class="img"
										v-if="shop.imagePath"
										v-bind:style="{
											'background-image':
												'url(' +
												rootImagePath +
												shop.imagePath +
												')'
										}"
									></div>
									<div
										class="img"
										v-else
										v-bind:style="{
											'background-image':
												'url(' +
												require('../../assets/image/NoImage.jpg') +
												')'
										}"
									></div>
								</div>
								<div class="score-comment">
									<div class="star-rating float-left">
										<font-awesome-icon
											:icon="
												shop.scoreAverage >= 5
													? ['fa', 'star']
													: ['far', 'star']
											"
											color="yellow"
										/>
										<font-awesome-icon
											:icon="
												shop.scoreAverage >= 4
													? ['fa', 'star']
													: ['far', 'star']
											"
											color="yellow"
										/>
										<font-awesome-icon
											:icon="
												shop.scoreAverage >= 3
													? ['fa', 'star']
													: ['far', 'star']
											"
											color="yellow"
										/>
										<font-awesome-icon
											:icon="
												shop.scoreAverage >= 2
													? ['fa', 'star']
													: ['far', 'star']
											"
											color="yellow"
										/>
										<font-awesome-icon
											:icon="
												shop.scoreAverage >= 1
													? ['fa', 'star']
													: ['far', 'star']
											"
											color="yellow"
										/>
									</div>
									<div
										class="comments float-right"
										style="color:#000;"
									>
										<font-awesome-icon
											:icon="['far', 'comment']"
											color="black"
										/>
										<b-badge class="shop-comment-badge">{{
											shop.commentsCount || 0
										}}</b-badge>
									</div>
								</div>
							</router-link>
						</swiper-slide>
						<div
							class="swiper-button-next"
							slot="button-next"
						></div>
						<div
							class="swiper-button-prev"
							slot="button-prev"
						></div>
					</swiper>
					<div
						v-if="!showAll[scIndex] && sc.shops.length >= 10"
						class="col-12 text-right mt-5"
					>
						<a
							@click="onShowAll(scIndex)"
							class="link-more btn text-dark"
							>مشاهده همه</a
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		rootImagePath: {
			type: String
		},

		provinceId: {
			type: String
		},

		provinceName: {
			type: String
		},

		shopCategories: {
			type: Array
		}
	},

	beforeMount() {
		this.initShopCategories();
		var q = this.$route.query.i || [];
		for (var i = 0; i < this.shopCategories.length; i++) {
			this.showAll.push(q[i] == "1" ? true : false);
		}
	},

	data() {
		return {
			loading: true,
			showAll: [],
			query: "",
			key: 1,
			_shopCategories: [],
			swiperOption: {
				slidesPerView: "auto",
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev"
				}
			}
		};
	},

	methods: {
		initShopCategories(e) {
			var query = e != null ? e.target.value : "";

			var result = [];
			var shopCategories = JSON.parse(
				JSON.stringify(this.shopCategories)
			);
			for (var i = 0; i < shopCategories.length; i++) {
				var shops = [];
				var shopCategory = shopCategories[i];

				if (shopCategory && shopCategory.shops) {
					for (var ii = 0; ii < shopCategory.shops.length; ii++) {
						const shop = shopCategory.shops[ii];

						if (query != "") {
							if (shop.name.includes(query)) {
								shops.push(shop);
							}
						} else {
							shops.push(shop);
						}
					}
				}

				if (shops.length > 0) {
					shopCategory.shops = shops;
					result.push(shopCategory);
				}
			}
			this.key = this.key + 1;
			this._shopCategories = result;
		},

		getQuery() {
			var result = [];
			for (var i = 0; i < this.showAll.length; i++) {
				result.push(this.showAll[i] == true ? 1 : 0);
			}

			return result;
		},

		onShowAll(i) {
			this.$set(this.showAll, i, true);

			const query = {
				...this.$route.query,
				i: this.getQuery()
			};

			this.$router.replace({ query });
		}
	}
};
</script>
<style scoped>
.shop-categories {
	width: 100%;
	float: right;
	text-align: center;
	position: relative;
	background: #eaeded;
}

.shop-categories .category {
	width: 100%;
	margin-top: 30px;
	float: left;
}

.shop-categories .content {
	width: 100%;
	float: right;
	padding-top: 30px;
}

.shop-categories .content .item {
	transition: all 0.5s;
	width: 100%;
	height: 370px;
	display: inline-block;
	padding: 10px;
	background: #fff;
}

.shop-categories .content .item .inner {
	width: 100%;
	height: 300px;
	float: right;
	position: relative;
}

.shop-categories .content .item .img {
	background-position: center center;
	background-size: cover;
	background-repeat: no-repeat;
	width: 100%;
	height: 290px;
}

.shop-categories .content .item .details {
	width: 100%;
	color: #000;
	text-align: right;
	font-weight: bold;
	font-size: 16px;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}

@media (max-width: 1024px) {
	.shop-categories .gradient {
		height: 230px;
	}

	.shop-categories .content .item {
		height: 230px;
		margin-bottom: 10px;
		padding: 5px;
	}

	.shop-categories .content .item .inner,
	.shop-categories .content .item .img {
		height: 160px;
	}
	.shop-categories .content .item .inner {
		margin-bottom: 10px;
	}

	.shop-categories .content .item .details {
		font-size: 14px;
	}
}

.slider,
.slider .item {
	width: 100%;
	float: left;
	height: 300px;
}

.slider {
	padding: 0 !important;
	margin-bottom: 0;
}

.slider .item {
	background: #292929;
}

.slider h1 {
	position: relative;
	text-align: center;
	color: #fff;
	font-size: 25px;
}

.section-title {
	width: 100%;
	text-align: center;
}

.section-title h2 {
	font-size: 18px;
	font-weight: 600;
	margin-bottom: 10px;
	padding-bottom: 20px;
	position: relative;
}

.section-title h2 a {
	color: inherit;
	text-decoration: none;
}

.section-title h2::before {
	content: "";
	position: absolute;
	display: block;
	width: 120px;
	height: 1px;
	background: #ddd;
	bottom: 1px;
	left: calc(50% - 60px);
}

.section-title h2::after {
	content: "";
	position: absolute;
	display: block;
	width: 40px;
	height: 3px;
	background: #d00918;
	bottom: 0;
	left: calc(50% - 20px);
}

.section-title p {
	margin-bottom: 0;
}

.section-title.light {
	color: #ddd;
}
</style>
